<template>
  <div>
    <!-- Add/Update Admin Form START -->
    <v-dialog persistent v-model="adminActionsModal" max-width="1000">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{ $t(`buttons.${isUpdate ? "update" : "add"}`) }}
          </div>
        </v-card-title>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(submitForm())">
            <v-card-text class="align-center">
              <v-row>
                <v-col cols="auto">
                  <ValidationProvider
                    :name="'IsActive'"
                    v-slot="{ errors }"
                  >
                    <v-checkbox
                      v-model="form.IsActive"
                      label="Aktif Hale Getir"
                      outlined
                      :error-messages="errors[0]"
                    ></v-checkbox>
                  </ValidationProvider>
                </v-col>
                <v-col cols="auto">
                  <ValidationProvider
                    :name="'Test'"
                    v-slot="{ errors }"
                  >
                    <v-checkbox
                      v-model="form.IsTest"
                      label="Test Seçim"
                      outlined
                      :error-messages="errors[0]"
                    ></v-checkbox>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <ValidationProvider
                :name="'Başlık'"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="form.Title"
                  label="Başlık"
                  outlined
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'Açıklama'"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="form.Description"
                  label="Açıklama"
                  outlined
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                name="Bölge"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="form.Department"
                  :items="regions"
                  label="Bölge"
                  :error-messages="errors"
                  outlined
                />
              </ValidationProvider>
              <ValidationProvider
                name="Vardiya"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="form.Shift"
                  :items="shifts"
                  label="Vardiya"
                  :error-messages="errors"
                  outlined
                />
              </ValidationProvider>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                small
                class="ma-2 mr-4"
                type="submit"
                elevation="0"
                large
                outlined
                color="red"
              >
                {{ $t(`buttons.${isUpdate ? "update" : "add"}`) }}
              </v-btn>
              <v-btn
                small
                class="ma-2 mr-4"
                elevation="0"
                large
                outlined
                color="grey"
                @click="adminActionsModal = false"
              >
                {{ $t("buttons.cancel") }}
              </v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- Add/Update Admin Form END -->

    <!-- Emergency deletion modal -->
    <delete-modal :yesFunc="deleteItem" ref="deleteModalRef" />
    <!-- Page content -->
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        <v-row>
          <v-col class="py-2">{{
            $t("navigationDrawerMenu.committeeElections")
          }}</v-col>
          <v-spacer />
          <v-btn
            small
            class="ma-2 mr-4"
            elevation="0"
            outlined
            color="info"
            @click="
              isUpdate = false;
              adminActionsModal = true;
            "
          >
            {{ $t("buttons.add") }}
          </v-btn>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <v-row justify="end">
          <!-- <v-col cols="3">
            <v-text-field
              v-model="sicilNumber"
              label="Sicil Numarası"
              clearable
              @keyup.enter="getItems"
            />
          </v-col> -->
          <v-col cols="2">
            <v-select
              v-model="itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="changeItemsPerPage()"
            />
          </v-col>
        </v-row>
        <v-data-table
          @click:row="item => {
            $router.push({
              name: 'committeeElectionDetail',
              params: { id: item.Id },
            })
          }"
          :item-class="() => 'clickable-row'"
          :headers="headers"
          :items="tableData"
          :loading="$store.state.loadingStatus"
          :options.sync="options"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
        >
          <!-- Fotoğrafı göstermek için örnek slot -->
          <template v-slot:item.PhotoFileId="{ item }">
            <v-avatar v-if="item.PhotoFileId" size="36">
              <img :src="item.PhotoFileId" alt="" />
            </v-avatar>
          </template>

          <template v-slot:item.Status="{ item }">
            <v-chip :color="item.Status === 10 ? 'green' : 'grey'" dark>
              {{ item.Status === 10 ? "Aktif" : "Pasif" }}
            </v-chip>
          </template>

          <template v-slot:item.IsActive="{ item }">
            <v-icon :color="item.IsActive ? 'green' : 'grey'">
              {{ item.IsActive ? "mdi-check-circle" : "mdi-close-circle" }}
            </v-icon>
          </template>

          <template v-slot:item.StartDate="{ item }">
            {{ item.StartDate ? formatDate(item.StartDate) : "-" }}
          </template>

          <template v-slot:item.EndDate="{ item }">
            {{ item.EndDate ? formatDate(item.EndDate) : "-" }}
          </template>

          <template v-slot:item.CreatedAt="{ item }">
            {{ formatDate(item.CreatedAt) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="
                    adminActionsModal = true;
                    changeActiveEvent(item, true);
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipEdit") }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.IsActive" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  color="red"
                  @click.stop="stopElection(item.Id)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-stop
                </v-icon>
              </template>
              <span>{{ $t("buttons.stop") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="
                    $router.push({
                      name: 'committeeElectionDetail',
                      params: { id: item.Id },
                    })
                  "
                  v-bind="attrs"
                  v-on="on"
                  >mdi-eye</v-icon
                >
              </template>
              <span>Detay</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div v-if="pages > 0" class="text-xs-center pt-2 md4 lg4">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CompanySelect from "../components/CompanySelect.vue";
import DeleteModal from "../components/General/DeleteModal";
import UpdatePassword from "../components/UpdatePassword.vue";
import ElectionsService from "../services/ElectionsService";
import NewcomersService from "../services/NewcomersService";
import { formatDate } from "../utils/common";

export default {
  data: () => ({
    sicilNumber: "",
    // List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    headers: [],

    //Pagination models
    pagination: {
      totalItems: 200,
      rowsPerPage: 15,
      page: 1,
    },
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],

    form: {
      Title: "",
      Description: "",
      Department: "",
      Shift: "",
    },
    adminActionsModal: false,
    isUpdate: false,
    deleteId: null,

    regions: [
      "1. Bölge",
      "2. Bölge",
      "3. Bölge",
      "4. Bölge",
      "5. Bölge",
      "ISG",
    ],
  }),

  watch: {
    adminActionsModal(newValue) {
      if (!newValue) {
        this.reset();
      }
    },
  },
  mounted() {
    this.setup();
    this.getItems();
  },
  components: {
    DeleteModal,
    UpdatePassword,
    CompanySelect,
  },

  computed: {
    shifts(){
      if(this.form.Department !== "ISG"){
        return [
          "A Vardiyası",
          "B Vardiyası",
          "C Vardiyası",
          "D Vardiyası",
          "E Vardiyası",
          "F Vardiyası",
          "Gündüz Vardiyası",
          "ISG",
        ]
      }

      return [
        "AKSA",
        "AKSAFIL",
      ]
    },
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage,
      );
    },
  },

  methods: {
    formatDate(date) {
      return formatDate(date);
    },
    setup() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.headers = [
        { text: "Başlık", value: "Title", sortable: false, align: "center" },
        {
          text: "Açıklama",
          value: "Description",
          sortable: false,
          align: "center",
        },
        // {
        //   text: "Başlangıç Tarihi",
        //   value: "StartDate",
        //   sortable: false,
        //   align: "center",
        // },
        // {
        //   text: "Bitiş Tarihi",
        //   value: "EndDate",
        //   sortable: false,
        //   align: "center",
        // },

        {
          text: "Bölge",
          value: "Department",
          sortable: false,
          align: "center",
        },

        {
          text: "Vardiya",
          value: "Shift",
          sortable: false,
          align: "center",
        },
        {
          text: "Oluşturulma Tarihi",
          value: "CreatedAt",
          sortable: false,
          align: "center",
        },
        { text: "Durum", value: "Status", sortable: false, align: "center" },
        {
          text: "İşlemler",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ];
    },

    getItems() {
      this.$store.state.loadingStatus = true;
      ElectionsService.getCommitteeElections({
        page: this.pagination.page,
        pageSize: this.pagination.rowsPerPage,
      })
        .then((response) => {
          const data = response.data;
          if (data) {
            this.tableData = data?.Data || [];
            this.pagination.totalItems = data.TotalData;
          }
        })
        .catch(window.showError)
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Change active event for click actions.
     * @param {any} item
     * @param {boolean} isUpdate
     */
    changeActiveEvent(item, isUpdate = false) {
      this.form = Object.assign(
        {
          Title: "",
          Description: "",
          Username: "",
          PhotoFileId: null,
          Position: "",
          photoFile: null,
        },
        item,
      );
      this.isUpdate = isUpdate;
    },

    async submitForm() {
      this.$store.state.loadingStatus = true;
      try {
        const payload = {
          Title: this.form.Title,
          Description: this.form.Description,
          Department: this.form.Department,
          Shift: this.form.Shift,
          IsTest: this.form.IsTest,
          IsActive: this.form.IsActive
        };

        if(this.isUpdate){
          payload['Id'] = this.form.Id;
        }
        
        await ElectionsService[`${this.isUpdate ? 'update' : 'create'}Election`](payload);
        this.adminActionsModal = false;
        this.getItems();
        window.showSuccess(
          this.$t(
            `messages.${
              this.isUpdate ? "updatedSuccessfully" : "addedAdminSuccessfully"
            }`,
          ),
        );
      } catch (e) {
        window.showError(e);
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },

    reset() {
      this.form = {
        Title: "",
        Description: "",
        Shift: "",
        Department: "",
      };
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },

    // Mock uploadFile fonksiyonu
    async uploadFile(file) {
      // Gerçek API entegrasyonunda burası değişecek
      // Şimdilik mock: 1 saniye bekle ve rastgele bir id dön
      await new Promise((r) => setTimeout(r, 1000));
      return Math.floor(Math.random() * 10000) + 1;
    },

    openDeleteModal(id) {
      this.deleteId = id;
      this.$refs.deleteModalRef.modalStatus = true;
    },

    stopElection(itemId){
      if(!itemId) return;

      this.$store.state.loadingStatus = true;
      ElectionsService.stopElection(itemId)
      .then(() => {
        this.getItems();
        window.showInfo(
            this.$t("messages.stoppedSuccessfully"),
            "standart",
            "success",
          );
      })
      .finally(() =>  this.$store.state.loadingStatus = false)
    },

    //Delete operation
    deleteItem() {
      this.$store.state.loadingStatus = true;
      ElectionsService.stopElection(this.deleteId)
        .then(() => {
          this.reset();
          window.showInfo(
            this.$t("messages.deletedSuccessfully"),
            "standart",
            "info",
          );
          this.getItems();
          this.$refs.deleteModalRef.modalStatus = false;
        })
        .catch(window.showError)
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    //Change displayed items per page, page number one is default
    changeItemsPerPage() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.pagination.page = 1;
      this.options.itemsPerPage = this.itemsPerPage;
      this.getItems();
    },

    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getItems();
    },
  },
};
</script>
